import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const DrawingDateTimeColumn = ({ data }: Props) => {
	const {
		state: { dataDrawingSelected },
	} = useTemplatesContext();
	if (data.id === -1) {
		return (
			<Grid
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid item style={{ alignItems: "center", justifyContent: "center" }}>
					{(dataDrawingSelected?.CreationTimestamp as string)?.slice(0, 10)}
				</Grid>
			</Grid>
		);
	} else if (data.id !== -1) {
		return <>{data?.CreationTimestamp?.slice(0, 10)}</>;
	} else return <></>;
};
